module.exports = "<div class=\"button-bar\">\n  <a class=\"btn btn-link\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">{{'COMMON.BUTTON.CANCEL'\n    | translate}}</a>\n  <button type=\"button\" [disabled]=\"!eventForm.valid\" (click)=\"saveClick()\" class=\"btn btn-primary\" data-se-id=\"saveButton\">\n    {{'COMMON.BUTTON.SAVE' | translate}}\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/add-event-button-bar/add-event-button-bar.component.html
// module id = eyPP
// module chunks = 0